import Vue from 'vue';
import { Module } from 'vuex';

import { LearningPathInfo, RootState } from 'frontend/types';

interface LearningPathsState {
  items: LearningPathInfo[];
}

const learningPaths: Module<LearningPathsState, RootState> = {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    learningPathsGrouped(state) {
      const numToShow = 4;
      return {
        head: state.items.slice(0, numToShow),
        tail: state.items.slice(numToShow),
      };
    },
    learningPathsAll(state: LearningPathsState): LearningPathInfo[] {
      return state.items;
    },
  },
  mutations: {
    setValue(state: LearningPathsState, value: LearningPathInfo[]): void {
      Vue.set(state, 'items', value);
    },
  },
  actions: {},
};

export default learningPaths;
